import NetworkRequestConfiguration from '@root/core/src/networking/network-request-configuration';

export default function getBoomerangContextConfiguration() {
  return new NetworkRequestConfiguration({
    endpoint: 'contexts/boomerang_context',
    method: NetworkRequestConfiguration.Methods.GET,
    errorCodes: [204, 500],
  });
}
